<template>
  <v-row
    v-resize="onResizeWindow"
    justify="center"
  >
    <v-col cols="12">
      <v-card>
        <v-toolbar class="primary">
          <v-toolbar-title>Инвентаризация</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Номер инвентаризации:
            </v-col>
            <v-col cols="12">
              Дата создания
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="form.type"
                label="Тип"
                :items="InventoryTypeArray()"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="form.pointId"
                label="Точка продаж"
                :items="points"
              />
            </v-col>
            <v-col cols="12">
              Комиссия
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="form.status"
                label="Статус"
                :items="DocumentStatusArray()"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.reason"
                label="Причина"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              Период
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <date-picker
                v-model="form.startDate"
                label="Начало периода"
              />
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <date-picker
                v-model="form.endDate"
                label="Конец периода"
              />
            </v-col>
            <v-col cols="12">
              <h3>
                Прогресс инвентаризации: {{ inventoryProgress }} %
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h3>
                Товаров к проверке: {{ goodsToBeChecked }}
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h3>
                Проверено: {{ checkedItems }}
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h3>
              Расхождений выявлено: {{ discrepanciesIdentified }}
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <h3>
              Сумма расхождений: {{ amountOfDiscrepancies }}
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                color="primary"
                outlined
                large
                min-width="100"
                class="mr-5"
                @click="() => onShowChooseNomenclatureDialog()"
              >
                Добавить
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                outlined
                color="info"
                large
                @click="onGetData"
              >
                Получить данные
              </v-btn>
            </v-col>
            <v-col cols="12">
              <div
                style="display: flex; flex-direction: row; cursor: pointer;"
                class="ml-2 mb-3"
                @click="onDeleteSelectedNomenclatures()"
              >
                <div>
                  <v-icon
                    medium
                    color="#aaaaaa"
                    class="mr-1"
                  >
                    mdi-delete
                  </v-icon>
                </div>
                <div style="color: #aaaaaa">
                  Убрать выбранные из таблицы
                </div>
              </div>
              <v-data-table
                v-model="selectedNomenclatures"
                :items-per-page="10"
                dense
                :items="form.items"
                :headers="[
                  {sortable: false, value: 'delete', text: 'Убрать'},
                  {value: 'productName', text: 'Товар'},
                  {value: 'accountingQuantity', text: 'Учётное'},
                  {value: 'actualQuantity', text: 'Фактическое'},
                  {value: 'discrepancy', text: 'Расхождение'},
                  {value: 'reason', text: 'Причина'},
                  {sortable: false, value: 'action', text: 'Дейсствие'},
                ]"
                :footer-props="datatableFooter"
                no-data-text="Нет данных для отображения"
                show-select
              >
                <template v-slot:item.delete="{ item }">
                  <v-icon
                    color="#aaaaaa"
                    class="mr-2"
                    style="cursor: pointer;"
                    @click="onDeleteNomenclature(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                  {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.reason===0"
                    color="warning"
                    @click="onShowInventoryDialog(item)"
                  >
                    mdi-text-box-edit-outline
                  </v-icon>
                  <v-icon
                    v-else
                    color="success"
                    @click="onShowInventoryDialog(item)"
                  >
                    mdi-text-box-check-outline
                  </v-icon>
                </template>
                <template v-slot:item.actualQuantity="{ item }">
                  <v-text-field
                    v-model="item.actualQuantity"
                    label="Фактическое"
                    type="number"
                    @change="onChangeActualQuantity(item)"
                  />
                </template>
                <template v-slot:item.discrepancy="{ item }">
                  {{ item.accountingQuantity - item.actualQuantity }}
                </template>
                <template v-slot:item.reason="{ item }">
                  {{ DiscrepancyReasonArray().find(f=>f.value === item.reason).text }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row class="d-flex justify-sm-space-around">
            <v-col
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                outlined
                color="primary"
                block
                @click="$router.go(-1)"
              >
                Отмена
              </v-btn>
            </v-col>
            <v-col
              v-if="!view"
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                color="primary"
                block
                @click="onSave"
              >
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>

    <dialog-nomenclature
      v-if="dialog.nomenclature.show"
      :items="nomenclatures"
      @close="onCloseDialog"
      @change="onAddNomenclature"
    />
    <v-dialog
      v-model="dialog.inventory.show"
      persistent
      :fullscreen="isMobile"
    >
      <v-card>
        <v-card-title>
          Инвентаризация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Товар: {{ dialog.inventory.item.productName }}
            </v-col>
            <v-col cols="12">
              Учётное количество: {{ dialog.inventory.item.accountingQuantity }}
            </v-col>
            <v-col cols="12">
              Фактическое количество: {{ dialog.inventory.item.actualQuantity }}
            </v-col>
            <v-col cols="12">
              Расхождение: {{ dialog.inventory.item.discrepancy }}
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="dialog.inventory.item.reason"
                :items="DiscrepancyReasonArray()"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="dialog.inventory.item.comment"
                label="Комментарий"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog.inventory.show=false">
            Закрыть
          </v-btn>
          <v-btn @click="onSaveInventoryDialog">
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import DialogNomenclature from "@/views/loyalty/shared/components/dialog-nomenclature/DialogNomenclature.vue"
import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
import { DiscrepancyReasonArray, DocumentStatusArray, InventoryTypeArray } from "@/views/loyalty/models/justpay-inventory.model"
import { JustpayInventoryService } from "@/views/loyalty/shared/services/justpay-inventory-service"
import DatePicker from "@/views/loyalty/shared/components/date-picker/DatePicker.vue"
import { JustpayRemainderService } from "@/views/loyalty/shared/services/justpay-remainder-service"

export default {
  name: 'InventoryForm',
  components: { DatePicker, DialogNomenclature },
  props: ['create', 'change', 'view'],
  data: () => ({
    // amountOfDiscrepancies: 0,
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: {
      nomenclature: {
        show: false,
        data: [],
        page: {}
      },
      inventory: {
        show: false,
        item: {}
      }
    },
    form: {
      created: null,
      endDate: new Date().toISOString(),
      number: null,
      items: [],
      pointId: null,
      reason: "",
      startDate: new Date().toISOString(),
      status: 0,
      type: 0

    },
    isMobile: false,
    isWider: false,
    justpayInventoryService: null,
    justpayRemainderService: null,
    nomenclatures: [],
    nomenclatureService: null,
    points: [],
    selectedNomenclatures: []
  }),
  computed: {
    amountOfDiscrepancies () {
      return this.form.items.filter(f => f.discrepancy !== 0).reduce((acc, item) => acc + item.price * item.discrepancy, 0)
    },
    checkedItems () {
      return this.form.items.filter(f => f.reason !== 0).length
    },
    discrepanciesIdentified () {
      return this.form.items.filter(f => f.discrepancy !== 0).length
    },
    goodsToBeChecked () {
      return this.form.items.length
    },
    inventoryProgress () {
      return (this.checkedItems / this.goodsToBeChecked) * 100
    }

  },
  // watch: {
  //   'form.items': {
  //       handler: function (oldValue, newValue) {
  //       // this.amountOfDiscrepancies()
  //         if (oldValue != newValue)
  //         {
  //           console.log("form.items is changed", newValue)
  //           // this.amountOfDiscrepancies = newValue.filter(f => f.discrepancy !== 0).reduce((acc, item) => acc + item.price * item.discrepancy, 0)
  //         this.form.items = newValue
  //         }
  //   },
  //   deep: true
  //     }
  // },
  beforeMount () {
    this.justpayInventoryService = new JustpayInventoryService()
    this.justpayRemainderService = new JustpayRemainderService()
  },
  async mounted () {
    const inventoryId = this.$route.query.id
    const response = await this.justpayInventoryService.getInit(inventoryId)
    if (inventoryId) {
      console.log('response', response)
      this.form = response.data
    }
    this.nomenclatures = response.nomenclatures
    this.points = response.points
    console.log('this.nomenclatures', this.nomenclatures)
  },
  methods: {
    DiscrepancyReasonArray () {
      return DiscrepancyReasonArray
    },
    DocumentStatusArray () {
      return DocumentStatusArray
    },
    InventoryTypeArray () {
      return InventoryTypeArray
    },
    onAddNomenclature (nomenclatures) {
      console.log('selectedNomenclatures', nomenclatures)
      const previouslySelectedNomenclaturesId = this.form.items.map(a => a.productId)
      console.log('previouslySelectedNomenclaturesId', previouslySelectedNomenclaturesId)
      this.form.items.push(
          ...nomenclatures.filter(
              a => (
                  !previouslySelectedNomenclaturesId.includes(a.id)
              )
          ).map(a => Object.assign({}, { productId: a.id, productName: a.name, accountingQuantity: 0, actualQuantity: 0, price: a.price, discrepancy: 0, reason: 0 }))
      )
      console.log('this.form.items', this.form.items)
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
    },
    onChangeActualQuantity (item) {
      console.log('item', item)
      this.form.items = this.form.items.map(m => {
        if (m.productId === item.productId) {
          m.discrepancy = m.accountingQuantity - item.actualQuantity
        }
        return m
      })
    },
    onCloseDialog () {
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
      console.log('dialog.nomenclature.data', this.dialog.nomenclature.data)
    },
    onDeleteNomenclature (item) {
      this.form.items = this.form.items.filter(a => a.productId !== item.productId)
    },
    onDeleteSelectedNomenclatures () {
      const selected_nomenclatures_id = this.selectedNomenclatures.map(a => a.productId)
      this.form.items = this.form.items.filter(a => !selected_nomenclatures_id.includes(a.productId))
      this.selectedNomenclatures = []
    },
    async onGetData () {
      const report = await this.justpayRemainderService.getReport(
          {
            beginPeriod: this.form.startDate,
            endPeriod: this.form.endDate,
            points: [this.form.pointId],
            nomenclatures: [...this.form.items.map(m => m.productId)]
          }
      )
          console.log('report', report)
      this.form.items = this.form.items.map(m => {
        const remainder = report.remainderResponses.find(f => f.nomenclatureId === m.productId)
        if (remainder) {
          m.accountingQuantity = remainder.remainderInPeriod
          m.discrepancy = m.accountingQuantity - m.actualQuantity
        }
        return m
      })
      console.log('this.form.items', this.form.items)
    },
    onResizeWindow () {
      const windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.isWider = windowSize.x > windowSize.y
      this.isMobile = windowSize.x < 600
    },
    async onSave () {
      if (this.form.id) {
        await this.justpayInventoryService.changeInventory(this.form)
      } else {
        await this.justpayInventoryService.createInventory(this.form)
      }
      this.$router.go(-1)
    },
    async onSaveInventoryDialog () {
      this.dialog.inventory.show = false
      console.log('dialog.inventory.item', this.dialog.inventory.item)
      this.form.items = this.form.items.map(m => {
        if (m.productId === this.dialog.inventory.item.productId) {
          m.reason = this.dialog.inventory.item.reason
          m.comment = this.dialog.inventory.item.comment
        }
        return m
      })
      await this.justpayInventoryService.changeInventory(this.form)
    },
    onShowChooseNomenclatureDialog () {
      this.dialog.nomenclature.show = true
    },
    onShowInventoryDialog (item) {
      this.dialog.inventory.show = true
      this.dialog.inventory.item = item
    }
  }
}
</script>

<style scoped>

</style>
